import {
  ChangeDetectionStrategy,
  Component,
  input,
  OnInit,
  output,
  signal,
  inject,
} from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import {
  NgbAccordionBody,
  NgbAccordionButton,
  NgbAccordionCollapse,
  NgbAccordionDirective,
  NgbAccordionHeader,
  NgbAccordionItem,
  NgbActiveOffcanvas,
} from '@ng-bootstrap/ng-bootstrap';
import { SidebarFooterComponent } from '../sidebar-footer/sidebar-footer.component';
import { KeeniconComponent } from '../../../keenicon/keenicon.component';
import { MenuItemInterface } from '../../../../types/sidemenu.interface';

@Component({
  selector: 'ui-sidebar-menu',
  imports: [
    RouterLink,
    RouterLinkActive,
    TranslocoDirective,
    KeeniconComponent,
    SidebarFooterComponent,
    NgbAccordionDirective,
    NgbAccordionItem,
    NgbAccordionHeader,
    NgbAccordionButton,
    NgbAccordionCollapse,
    NgbAccordionBody,
  ],
  templateUrl: './sidebar-menu.component.html',
  styleUrl: './sidebar-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarMenuComponent implements OnInit {
  protected activeOffcanvas = inject(NgbActiveOffcanvas);
  private router = inject(Router);

  PAGE_ROUTES = input.required<{ [key: string]: string }>();
  menuItems = input.required<MenuItemInterface[]>();
  lockedItemClick = output<void>();
  activeItem = signal('');

  ngOnInit() {
    this.logCurrentRoute();
  }

  onLockedItemClick() {
    this.lockedItemClick.emit();
  }

  private logCurrentRoute(): void {
    const basePath = this.router.url.split('/')[1];
    this.activeItem.set(`/${basePath}`);
  }
}
